import { TFunction } from '@translations/useTranslations'
import { translateActiveLocale } from '@utils/i18n'

type BusinessFailureTypename =
  | 'CopyProcessesSameSourceAndTargetError'
  | 'DuplicateProcessError'
  | 'MissingMainCuttingMaterialError'
  | 'MultipleMainCuttingMaterialsError'
  | 'PlannedQuantityBelowReservedError'
  | 'PlannedQuantityExceedsRemainingError'
  | 'ResponsibleContributorRemovalError'

const BUSINESS_FAILURE_TYPENAMES: string[] = [
  'CopyProcessesSameSourceAndTargetError',
  'DuplicateProcessError',
  'MissingMainCuttingMaterialError',
  'MultipleMainCuttingMaterialsError',
  'PlannedQuantityBelowReservedError',
  'PlannedQuantityExceedsRemainingError',
  'ResponsibleContributorRemovalError'
] satisfies BusinessFailureTypename[]

const getErrorMessageByTypename = (
  typename: BusinessFailureTypename,
  t: TFunction
) => {
  switch (typename) {
    case 'CopyProcessesSameSourceAndTargetError':
      return t('errors.copyProcessesSameSourceAndTarget')
    case 'DuplicateProcessError':
      return t('messages.duplicationOfProcessesMessage')
    case 'MissingMainCuttingMaterialError':
      return t('errors.missingMainCuttingMaterial')
    case 'MultipleMainCuttingMaterialsError':
      return t('errors.multipleMainCuttingMaterials')
    case 'PlannedQuantityBelowReservedError':
      return t('errors.plannedQuantityBelowReserved')
    case 'PlannedQuantityExceedsRemainingError':
      return t('errors.plannedQuantityExceedsRemaining')
    case 'ResponsibleContributorRemovalError':
      return t('errors.responsibleContributorRemoval')
    default: {
      const unhandled: never = typename
      return unhandled
    }
  }
}

export const getFailureMessage = (typename: string) =>
  BUSINESS_FAILURE_TYPENAMES.includes(typename)
    ? getErrorMessageByTypename(
        typename as BusinessFailureTypename,
        translateActiveLocale
      )
    : undefined
